import { BaseModel } from "@puntaje/shared/core"

export class EntrenadorMeta extends BaseModel {
    entrenador_meta: string
    numero_preguntas: number
    entrenador_nombre_meta: string
}
